module.exports = __webpack_public_path__ + "img/waffel_icon.989161fa.png";